import { isFreePlan } from "@app/analytics/account/Billing/utils";
import CustomVocabularyModuleContent, {
  CustomVocabularyModuleUpsell,
} from "@app/analytics/account/components/CustomVocabularyModuleContent";
import Setting from "@app/analytics/account/components/Setting";
import SettingsModule from "@app/analytics/account/components/SettingsModule";
import { Divider } from "@app/analytics/account/components/styles";
import type { SettingModule } from "@app/analytics/account/types";
import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import useCustomVocabulary from "@app/analytics/hooks/settings/useCustomVocabulary";
import useWorkspace from "@app/common/workspaces/useWorkspace";

const CustomVocabularyModule = (props: SettingModule) => {
  const { currentPlan, plansInitialLoading } = useBillingContext();
  const { inWorkspace } = useWorkspace();

  const { customVocabulary, isLoading: customVocabularyIsLoading } =
    useCustomVocabulary();

  const isLoading = plansInitialLoading || customVocabularyIsLoading;
  const showUpsell = !isLoading && isFreePlan(currentPlan.type);

  return (
    <>
      <SettingsModule {...props} spacing={1}>
        <Divider />
        {showUpsell ? (
          <CustomVocabularyModuleUpsell
            hasVocabulary={customVocabulary.length > 0}
            planLabel={currentPlan.label}
          />
        ) : (
          <Setting
            subtitle="Adding words to your custom vocabulary helps boost recognition in the transcript. This improves accuracy for names, product terms, and jargon."
            spacing={2}
          >
            <CustomVocabularyModuleContent
              inWorkspace={inWorkspace}
              isLoading={isLoading}
            />
          </Setting>
        )}
      </SettingsModule>
    </>
  );
};

export default CustomVocabularyModule;
